export default __webpack_public_path__ + "f1aea7a8abe8bd902d907349029841af.svg";